// import React, { Component } from 'react';
import { globalModalStore } from '../../stores';
import { observer } from 'mobx-react';

const GlobalModal = () => globalModalStore.currentModal;

export default observer(GlobalModal);
